/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import {
  AccordionDataTableRowDefault,
  AccordionDataTableRowDefaultProps,
} from 'components/accordion/accordion-data-table/AccordionDataTableRowDefault'
import { AccordionDataTableRowIcon } from 'components/accordion/accordion-data-table/AccordionDataTableRowIcon'
import { BadgeNotificacao } from 'components/notificacao/BadgeNotificacao'
import { CuidadoCompartilhadoItem } from 'view/cuidados-compartilhados/model-cuidadoCompartilhado'

interface ListaCuidadoCompartilhadoTableRowProps extends AccordionDataTableRowDefaultProps<CuidadoCompartilhadoItem> {}

export function ListaCuidadoCompartilhadoTableRow<T>(props: Readonly<ListaCuidadoCompartilhadoTableRowProps>) {
  const { row, columns, disabled, style } = props

  const notificar = row.topicoNotificacao?.statusNotificarLido

  const IconWithBadge = (
    <div css={classes.badgeContainer}>
      {notificar && (
        <div css={classes.badge}>
          <BadgeNotificacao value='Novo' type='large' color='blue' />
        </div>
      )}
      <AccordionDataTableRowIcon disabled={disabled} />
    </div>
  )
  return (
    <AccordionDataTableRowDefault row={row} columns={columns} disabled={disabled} style={style} icon={IconWithBadge} />
  )
}

const classes = {
  badgeContainer: css`
    position: relative;
    display: inline-flex;
    align-items: center;
  `,
  badge: css`
    position: absolute;
    top: -30px;
    right: -10px;
  `,
}
